import { newShortId } from '@beamible/uuid';
import * as Collections from '@pkg/utils/collections';
import { DesignEntity } from '@/lib/enums';
import { isPeriodCategory } from '../../period';
import useNextColor from '../../useNextColor';

/**
 * @param {Object} state
 * @param {Object[]} state.tags
 * @param {Object[]} state.categories
 * @param {Object} input
 * @param {String} input.category_uuid
 * @returns {Object}
 */
export default function add({ tags, categories }, properties) {
  const { category_uuid, color, name, uuid } = properties;

  const categoryId =
    !category_uuid || category_uuid === 'primary' ? null : category_uuid;

  const category = categories.map.get(categoryId) ?? null;
  if (isPeriodCategory(category)) {
    return null;
  }
  const categoryTags = Collections.groupBy(tags.list, 'category_uuid');

  const tag = {
    uuid: uuid || newShortId(),
    category_uuid: category?.uuid ?? null,
    name: name || 'New tag',
    description: '',
    color: color ?? category?.color ?? useNextColor(categoryTags[categoryId]),
    order:
      Math.max(-1, ...(categoryTags[categoryId]?.map((t) => t.order) ?? [])) +
      1,
    taggables: category?.taggables ?? [
      DesignEntity.GROUP,
      DesignEntity.ROLE,
      DesignEntity.ACTIVITY,
    ],
  };

  return {
    tags: {
      create: [tag],
    },
  };
}
